import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { omapApi } from '../../services/omapApi';

interface VigilNotification {
  id: number;
  task_type: string;
  severity: string;
  title: string;
  summary: string;
  details: Record<string, any>;
  status: string;
  created_at: string;
}

interface VigilState {
  notifications: VigilNotification[];
  loading: boolean;
  error: string | null;
}

const initialState: VigilState = {
  notifications: [],
  loading: false,
  error: null,
};

export const fetchVigilNotifications = createAsyncThunk(
  'vigil/fetchNotifications',
  async (companyId: number) => {
    const data = await omapApi.getVigilNotifications(companyId);
    return data.notifications || [];
  }
);

export const dismissNotificationAsync = createAsyncThunk(
  'vigil/dismiss',
  async (notificationId: number) => {
    await omapApi.dismissVigilNotification(notificationId);
    return notificationId;
  }
);

const vigilSlice = createSlice({
  name: 'vigil',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchVigilNotifications.pending, (state) => { state.loading = true; })
      .addCase(fetchVigilNotifications.fulfilled, (state, action) => {
        state.loading = false;
        state.notifications = action.payload;
      })
      .addCase(fetchVigilNotifications.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || 'Failed to fetch notifications';
      })
      .addCase(dismissNotificationAsync.fulfilled, (state, action) => {
        state.notifications = state.notifications.filter(n => n.id !== action.payload);
      });
  },
});

export default vigilSlice.reducer;
